<template>
  <div class="account-form__container"
       :class="{'account-form__container--shadow': floatingBox}">
    <div class="account-form__inner">
      <div v-if="heading"
           class="account-form__heading">
        <h4>{{ heading }}</h4>
      </div>
      <div class="account-form__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccountFormContainer",
  props: {
    heading: {
      type: String,
      default: null,
    },
    floatingBox: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
